
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/context/AuthContext";

export const useNuvemshopIntegration = () => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['nuvemshop-integration', user?.id],
    queryFn: async () => {
      if (!user?.id) {
        console.log('👤 [NUVEMSHOP_INTEGRATION] No user ID available');
        return null;
      }
      
      console.log('🔍 [NUVEMSHOP_INTEGRATION] Checking integration for user:', user.id);
      
      // Buscar tokens ativos primeiro
      const { data: tokenData, error: tokenError } = await supabase
        .from('nuvemshop_tokens')
        .select('store_id, is_active, created_at')
        .eq('user_id', user.id)
        .eq('is_active', true)
        .order('created_at', { ascending: false })
        .limit(1);

      console.log('🔍 [NUVEMSHOP_INTEGRATION] Token query result:', {
        tokenData,
        tokenError,
        foundTokens: tokenData?.length || 0
      });

      if (tokenError) {
        console.error('🚨 [NUVEMSHOP_INTEGRATION] Error fetching tokens:', tokenError);
        return null;
      }

      // Buscar configuração da integração
      const { data: integrationData, error: integrationError } = await supabase
        .from('integrations')
        .select('status, config, connection_status')
        .eq('user_id', user.id)
        .eq('integration_type', 'nuvemshop')
        .single();

      console.log('🔍 [NUVEMSHOP_INTEGRATION] Integration query result:', {
        integrationData,
        integrationError
      });

      if (integrationError && integrationError.code !== 'PGRST116') {
        console.error('🚨 [NUVEMSHOP_INTEGRATION] Error fetching integration config:', integrationError);
      }

      const hasToken = tokenData && tokenData.length > 0;
      const storeId = hasToken ? tokenData[0].store_id : null;

      const result = {
        hasToken,
        storeId,
        status: integrationData?.status || (hasToken ? 'connected' : 'disconnected'),
        connectionStatus: integrationData?.connection_status || (hasToken ? 'connected' : 'disconnected'),
        config: integrationData?.config || null
      };

      console.log('✅ [NUVEMSHOP_INTEGRATION] Final result:', result);
      return result;
    },
    enabled: !!user?.id,
    staleTime: 30000, // 30 segundos
    refetchOnWindowFocus: true,
  });
};
